import { displayError } from '../presentation/display-error'
import { identity, requestId } from '@/network/session-identity'
export { identity, requestId } from '@/network/session-identity'
import axios from 'axios'
import { aiLightRequest } from '@/ai/services/request'
import { ReturnBaseUrl } from '@/network/request'

// 仅保存登录协商结果，不缓存对话、动作令牌或供应商密钥。
const key = 'aiCapabilities:v1'
export function recordLoginAiCapabilities(data) {
  // 每次成功登录开启新会话周期；刷新和页面跳转不重置。
  sessionStorage.setItem('aiLoginEpoch', requestId())
  sessionStorage.setItem(
    key,
    JSON.stringify({
      server: ReturnBaseUrl(),
      user: data.userId,
      value: data.aiCapabilities || { enabled: false }
    })
  )
}
export function capabilities() {
  try {
    const cached = JSON.parse(sessionStorage.getItem(key))
    if (
      cached &&
      cached.server === ReturnBaseUrl() &&
      cached.user === sessionStorage.getItem('userId')
    )
      return cached.value
  } catch (_) {
    /* 缺失协商时不探测接口。 */
  }
  return { enabled: false }
}
// 服务支持能力与账号使用权限分离，旧的登录响应可按协议能力识别。
export function supportsAi(value = capabilities()) {
  return value.supported === true || (Array.isArray(value.supportedProtocolMajors) && value.supportedProtocolMajors.includes(1))
}
export function createAiClient(basePath = '/ai/v1') {
  const scope = identity()
  const token = sessionStorage.getItem('token')
  const baseURL = ReturnBaseUrl() + basePath
  const source = axios.CancelToken.source()
  return {
    close() {
      source.cancel('AI_PAGE_CLOSED')
    },
    async post(path, data = {}) {
      if (scope !== identity()) throw new Error('ACCOUNT_CHANGED')
      const response = await aiLightRequest({ method: 'post', baseURL, url: path, data: { ...data, token }, cancelToken: source.token })
      if (response.data && response.data.code === 6) {
        const error = new Error('TOKEN_ERROR'); error.silent = true; error.definitive = true; throw error
      }
      if (scope !== identity()) throw new Error('ACCOUNT_CHANGED')
      if (!response.data || response.data.code !== 0) {
        const error = new Error(
          (response.data && response.data.data && response.data.data.errorCode) || 'AI_UNAVAILABLE'
        )
        const details = response.data && response.data.data
        error.errorCode = error.message
        error.traceId = details && details.traceId
        error.retryable = !!(details && details.retryable)
        if (details && typeof details.displayMessage === 'string') error.displayMessage = details.displayMessage
        // 内部异常可能发生在提交之后，仍保留幂等重试；明确拒绝才解锁输入。
        error.definitive =
          !!response.data &&
          !!response.data.data &&
          typeof response.data.data.errorCode === 'string' &&
          error.message !== 'AI_UNAVAILABLE'
        throw error
      }
      return response.data.data
    }
  }
}
export function errorMessage(error, fallback) {
  if (error && (error.silent || error.message === 'TOKEN_ERROR' || (axios.isCancel && axios.isCancel(error)))) return ''
  return displayError(error, fallback)
}
